import {block} from '../../utils/cn';

export const cnFileDropZone = block('file-drop-zone');
